module.exports = new __parcel__URL__("coinbase.c169dc7d.svg").toString();